import React, { FC } from "react";
import Modal, { ModalController } from "Components/Modal/Modal";
import { Box, DialogContent, makeStyles } from "@material-ui/core";
import ModalTitle from "Components/Modal/ModalTitle";
import { ExternalChatOrganization, ExternalChatUserState, } from "domain-entities";
import OrganizationSignInView from "./OrganizationSignInView";
import { SaveDocumentStore } from "Helpers/StoreHelper";
import { px } from "../../Configs/theme";

interface Props {
  modalController: ModalController<ExternalChatOrganization>;
  viewerUserStateStore: SaveDocumentStore<ExternalChatUserState>;
}

const OrganizationSignInModal: FC<Props> = (props) => {
  const classes = useStyles();

  if (props.modalController.isOpen && props.modalController.item) {
    const organisation = props.modalController.item;
    const organisationModelTitle = organisation.location?.name ? "" : organisation.name;

    return (
        <Modal
            // pagePath={TrackingPage.AUTH_SIGN_OUT}
            modalController={props.modalController}
        >
          <ModalTitle close={props.modalController.close} title={organisationModelTitle}>
            {organisation.location && (
                <Box className={classes.header}>
                  <Box className={classes.organizationName}>
                    {organisation.name}
                  </Box>
                  <Box className={classes.organizationLocation}>
                    {organisation.location.name}
                  </Box>
                </Box>
            )}
          </ModalTitle>
          <DialogContent>
            <OrganizationSignInView
                organization={organisation}
                viewerUserStateStore={props.viewerUserStateStore}
                modalController={props.modalController}
            />
          </DialogContent>
        </Modal>
    );
  } else {
    return null;
  }
};

export default OrganizationSignInModal;

const useStyles = makeStyles({
  header: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  organizationName: {
    fontSize: "18px",
    fontWeight: "bold",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    marginBottom: px.xs,
  },
  organizationLocation: {
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "capitalize",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    opacity: 0.5,
  }
});
